'use strict';

// Global navigation dropdown navigation
{

  const dropdown = {

    el: {
      containerClass: '.js_dropdown-container',
      containerAndHeaderClass: '.js_dropdown-container, .header',
      headerClass: '.header',
      headerLinkClass: '.header .nav__item:not(.js_dropdown-link)',
      $headerTopPage: $('.header__top-wrapper'),
      linkClass: '.js_dropdown-link',
      $overlay: $('.js_nav-dropdown-overlay'),
      target: ''
    },

    flag: {
      topPos: false
    },

    init(target) {
      this.el.target = target;

      this.showDropdownHandler();
      this.hideDropdownHandler();
      if ($('.header__top-wrapper').length) {
        this.scrollHandler();
      }
    },

    showDropdownHandler() {
      const _this = this;

      $(_this.el.linkClass + _this.el.target).on('mouseenter', function () {
        const target = '.' + $(this).data('src');
        const $header = $(this).closest(_this.el.headerClass);
        const $containers = $header.find(_this.el.containerClass);
        const $container = $header.find(_this.el.containerClass + target);

        $containers.stop().fadeOut().removeClass('active').removeClass('active-top');

        $(this).addClass('active');
        _this.setHeaderHeightOffset($header, $container);
        $container.stop().fadeIn().addClass('active');
        _this.el.$overlay.stop().fadeIn().addClass('active');

        if (_this.flag.topPos) {
          $container.addClass('active-top');
        }
      });
    },

    hideDropdownHandler() {
      const _this = this;

      $(_this.el.containerAndHeaderClass).on('mouseleave', function () {
        const $container = $(_this.el.containerClass);

        $(_this.el.linkClass + _this.el.target).removeClass('active');
        $container.stop().fadeOut().removeClass('active').removeClass('active-top');
        _this.el.$overlay.stop().fadeOut().removeClass('active');
      });

      $(_this.el.headerLinkClass).on('mouseenter', function () {
        const $container = $(_this.el.containerClass);

        if ($container.hasClass('active')) {
          $container.stop().fadeOut().removeClass('active').removeClass('active-top');
          _this.el.$overlay.stop().fadeOut().removeClass('active');
        }
      });
    },

    setHeaderHeightOffset($header, $container) {
      let height = $header.outerHeight();
      if ($header.hasClass('header__sticky')) {
        //height += 2;
      }

      if (this.flag.topPos) {
        $container.css('top', 'inherit').css('bottom', height + 'px');
      } else {
        $container.css('bottom', 'inherit').css('top', height + 'px');
      }
    },

    scrollHandler() {
      $(window).on('scroll', () => {
        const scrollPos = $(window).scrollTop();
        const isHeaderBelow = this.isHeaderBelow(scrollPos);

        if (isHeaderBelow) {
          this.setTopPositionFlag(true);
        } else {
          this.setTopPositionFlag(false);
        }
      });
    },

    isHeaderBelow(scrollPos) {
      const headerPos = this.el.$headerTopPage.offset().top;
      const headerHeight = this.el.$headerTopPage.outerHeight()();
      const windowHeight = $(window).height();
      const headerPosCenterScreen = headerPos - (windowHeight / 2) + (headerHeight / 2);
      if (scrollPos < headerPosCenterScreen) {
        return true;
      }
    },

    setTopPositionFlag(topPosStatus) {
      this.flag.topPos = topPosStatus;
    },

  };

  if ($('.js_dropdown-products').length) {
    dropdown.init('.js_dropdown-products');
  }

}

// Sticky global navigation
{

  const stickyNav = {

    el: {
      $header: $('.header'),
      stickyHeaderClass: 'header__sticky'
    },

    config: {
      stickyEnabled: false,
      stickyCreated: false,
      stickyHeight: 104,
      stickyHeightNarrow: 106
    },

    init() {
      this.scroll();
    },

    scroll() {
      const _this = this;
      let scrollPos;
      let stickyPos;

      $(window).scroll(function () {

        const offset = $(window).height() / 2;
        scrollPos = $(window).scrollTop();
        stickyPos = _this.el.$header.offset().top + offset;

        if (scrollPos > stickyPos && _this.config.stickyEnabled !== true) {
          if (_this.config.stickyCreated !== true) {

            _this.createStickyNav();
            _this.fadeIn();

            _this.config.stickyCreated = true;
          } else {
            _this.fadeIn();
          }

          _this.config.stickyEnabled = true;
        }

        if (scrollPos < stickyPos && _this.config.stickyEnabled !== false) {
          _this.fadeOut();

          _this.config.stickyEnabled = false;
        }

      });

    },

    createStickyNav() {
      this.el.$header.clone(true, true).addClass(this.el.stickyHeaderClass).prependTo('body');
    },

    slideDown() {
      $(`.${this.el.stickyHeaderClass}`).stop().animate({
        top: '0'
      }, 500);
    },

    slideUp() {
      $(`.${this.el.stickyHeaderClass}`).stop().animate({
        top: `-${this.config.stickyHeight}`
      }, 500);
    },

    fadeIn() {
      $(`.${this.el.stickyHeaderClass}`).stop().animate({
        opacity: '1'
      }, 500).addClass('active');
    },

    fadeOut() {
      $(`.${this.el.stickyHeaderClass}`).stop().animate({
        opacity: '0'
      }, 500).removeClass('active');
    }

  };

  // Only enable the sticky dropdown navigation on the top page
  if ($('.header').length) {
    stickyNav.init();
  }

}

// Slide to section links
$('.js_link').on('click', function (e) {
  e.preventDefault();
  let headerHeight = 0;
  if ($('.header__sticky').hasClass('active')) {
    headerHeight = 104;
  }
  let fromTopOffset = $(this).data('offset');
  if (!fromTopOffset) {
    fromTopOffset = 0;
  }

  const target = $(this).attr('href');
  const offset = $(target).offset().top - headerHeight - fromTopOffset;
  $('html,body').animate({ scrollTop: offset }, 700);
  return 0;
});

// Video modal
$('.js_video-popup').magnificPopup({
  type: 'iframe',
  mainClass: 'mfp-fade',
  removalDelay: 160,
  preloader: false,
  fixedContentPos: false
});

// Search iFrame resizer
{
  const searchIframeResizer = {
    el: {
      $searchIframe: $('.js_search-container iframe')
    },

    init() {
      this.initializeResizer();
      this.adjustPositionOnNav();
      this.adjustLoadPosition();
      this.disableScrollRestoration();
    },

    initializeResizer() {
      const $iframe = this.el.$searchIframe;

      $iframe.on('load', function () {
        $iframe.iFrameResize({ checkOrigin: false });
      });
      $iframe.triggerHandler('load');
    },

    adjustLoadPosition() {
      document.querySelector('#navitime-package').onload = function () {
        window.parent.document.body.scrollTop = 0;
        window.parent.document.documentElement.scrollTop = 0;
      };
    },

    adjustPositionOnNav() {
      window.onscroll = function () {
        const topHeight = $(window).scrollTop() - $('#navitime-package').position().top;
        window.frames['navitime-package'].contentWindow.postMessage(topHeight, '*');
      };
    },

    disableScrollRestoration() {
      if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'manual';
      }
    }
  };

  if ($('.js_search-container').length) {
    searchIframeResizer.init();
  }
}

// Top page slider
{

  const slider = {

    el: {
      $slider: $('.js_slider'),
      transitionTime: 1000,
      autoplaySpeed: 5000
    },

    init() {
      this.adjustSlideHeight();
      this.initializeSlick();
    },

    initializeSlick() {
      this.el.$slider.slick({
        autoplay: true,
        fade: true,
        draggable: true,
        swipe: true,
        speed: this.el.transitionTime,
        autoplaySpeed: this.el.autoplaySpeed,
        slidesToShow: 1,
        initialSlide: 0,
        dots: true,
        arrows: false
      });
    },

    adjustSlideHeight() {
      this.el.$slider.on('init', function () {
        const windowHeight = $(window).height();

        const headerHeight = $('.header__top-wrapper').outerHeight()();
        const newsHeight = $('.news--small').height();

        const slideHeight = windowHeight - headerHeight - newsHeight - 2;

        $('.slider__slide').css('height', slideHeight + 'px');
      });
    }

  };

  if ($('.js_slider').length) {
    slider.init();
  }

}

// Top page animated text
{

  const animatedText = {

    el: {
      texts: {
        text1: {
          el: $('.js_intro-text1'),
          offset: -0.1
        },
        text2: {
          el: $('.js_intro-text2'),
          offset: -0.1
        }
      }
    },

    conf: {
      // e.g. starting at 80% down from the top of the screen
      animationStartPoint: 0.85
    },

    init() {
      this.scrollHandler();
    },

    scrollHandler() {
      $(window).on('scroll', () => {
        this.triggerAnimation();
      });
    },

    triggerAnimation() {
      const currentPos = $(document).scrollTop();
      const items = this.el.texts;

      for (let key in items) {
        const $textElement = items[key].el;
        const triggerPositionOffset = items[key].offset;
        const windowHeight = $(window).height();

        const triggerPos = $textElement.offset().top - (windowHeight * this.conf.animationStartPoint) + (windowHeight * triggerPositionOffset);
        if (currentPos > triggerPos) {
          this.animateText($textElement);
        }
      };
    },

    animateText($text) {
      $text.addClass('active');
    }

  };

  if ($('.js_intro-text1').length) {
    animatedText.init();
  }

}

// Top page slider
{

  const videoBackground = {

    el: {
      $container: $('.js_video-bg')
    },

    init() {
      this.initializeYouTubeBackground();
    },

    initializeYouTubeBackground() {
      this.el.$container.YTPlayer({
        fitToBackground: true,
        videoId: 'kVa0iHa9sew'
        // playerVars: {
        //   modestbranding: 1,
        //   autoplay: 1,
        //   controls: 0,
        //   showinfo: 0,
        //   branding: 0,
        //   rel: 0,
        //   autohide: 0
        // }
      });
    }

  };

  if ($('.js_video-bg').length) {
    videoBackground.init();
  }

}


// Change URL on scroll
{

  const urlChangeOnScroll = {

    el: {
      $changePoint: $('.js_change-url')
    },

    init() {
      this.scrollHandler();
      this.urlHandler();
    },

    scrollHandler() {
      const _this = this;

      let belowChangePoint = false;
      let usedBelowChangePoint = false;
      let aboveChangePoint = true;
      let usedAboveChangePoint = false;

      $(window).on('scroll', function () {

        if ($(this).scrollTop() >= _this.el.$changePoint.position().top) {
          if (belowChangePoint) {
            if (!usedBelowChangePoint) {
              _this.rewriteURL('below');
              usedBelowChangePoint = true;
              usedAboveChangePoint = false;
            }
          } else {
            belowChangePoint = true;
            aboveChangePoint = false;
          }
        } else {
          if (aboveChangePoint) {
            if (!usedAboveChangePoint) {
              _this.rewriteURL('above');
              usedAboveChangePoint = true;
              usedBelowChangePoint = false;
            }
          } else {
            aboveChangePoint = true;
            belowChangePoint = false;
          }
        }

      });

    },

    rewriteURL(position) {
      const pageURL = window.location.href;

      let baseURL = this.el.$changePoint.data('base-url');
      let changeURL = this.el.$changePoint.data('change-url');

      if (pageURL.indexOf("/nov/brand/") !== -1) {
        baseURL = '/nov/brand' + baseURL;
        changeURL = '/nov/brand' + changeURL;
      }

      if (pageURL.indexOf("/stg/") !== -1) {
        baseURL = '/stg' + baseURL;
        changeURL = '/stg' + changeURL;
      }

      if (position === 'above') {
        history.replaceState(null, null, baseURL);
      } else {
        history.replaceState(null, null, changeURL);
      }
    },

    urlHandler() {
      const pageURL = window.location.href;

      let baseURL = window.location.pathname;
      let changeURL = this.el.$changePoint.data('change-url');

      if (pageURL.indexOf("/nov/brand/") !== -1) {
        changeURL = '/nov/brand' + changeURL;
      }

      if (pageURL.indexOf('/stg/') !== -1) {
        changeURL = '/stg' + changeURL;
      }

      if (baseURL === changeURL) {
        this.goToURLPosition();
      }
    },

    goToURLPosition() {
      const $target = this.el.$changePoint;

      const headerHeight = 65;

      const offset = $target.offset().top - headerHeight;
      $('html,body').animate({ scrollTop: offset }, 0);
    }

  };

  if ($('.js_change-url').length) {
    urlChangeOnScroll.init();
  }

}


/* ----------------------------------------------------------
  pageScroll
---------------------------------------------------------- */
$(function(){
  $('.js-scroll').click(function() {
    var speed = 700; // スクロールスピード
    var href= $(this).attr("href");
    //var headerH = $('.header').outerHeight();
    var headerH = 104;
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top - headerH;
    if(href == '#'){
      // リンク#のときはページの先頭へ
      $('body,html').animate({scrollTop:0}, speed, 'swing');
    } else {
      // それ以外は指定idへ
      $('body,html').animate({scrollTop:position}, speed, 'swing');
    }
    return false;
  });
});


/* ----------------------------------------------------------
  macth height nov3 page
---------------------------------------------------------- */
$(function(){
  $('.list-product__box-detail').matchHeight();
  $('.list-product-link__text').matchHeight();
  $('.list-howto-step__inner').matchHeight();
});

/* ----------------------------------------------------------
  click able map
---------------------------------------------------------- */
$(document).ready(function(e) {
  $('.box-makeup-recommend__image img').maphilight();
  $('img[usemap]').rwdImageMaps();
});

/* ----------------------------------------------------------
  accordion
---------------------------------------------------------- */
$(function() {
  $('.faq__detail').hide();
  $(".faq__title").click(function(event){
    event.preventDefault();
    if(!$(this).hasClass("is-active")) {
      $(this).next().slideDown();
      $(this).addClass("is-active");
    } else {
      $(this).next().slideUp();
      $(this).removeClass("is-active");
    }
  });
});

/* ----------------------------------------------------------
 link_jump
---------------------------------------------------------- */
$(function(){
  link_jump();
});

var link_jump = function(){
  var hash = window.location.hash;
  if(hash && $(hash).length > 0) {
    let headerHeight = 104;
    if($(hash).hasClass('faq__title')) {
      console.log(hash);
      $(hash).addClass('is-active');
      $(hash).next().slideDown();
    }
    // if ($('.header__sticky').hasClass('active')) {
    //   headerHeight = 104;
    // }
    var targetY = $(hash).offset().top - headerHeight;
    var targetYCount = targetY;
    $(window).scrollTop(0);
    $('body,html').animate({scrollTop:targetYCount}, 1000, 'swing');
  }
}
